import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './textarea.module.scss';

function TextArea({
    value,
    placeholder,
    rows,
    isActive,
    focusOnShow,
    disabled,
    readOnly,
    onClear,
    ...textareaProps
}) {
    const textareaElement = useRef();

    const focusTextarea = () => {
        textareaElement.current?.focus();
        textareaElement.current?.setSelectionRange(value.length, value.length);
    };

    useEffect(() => {
        if (focusOnShow) {
            focusTextarea();
        }
    }, [focusOnShow]); // eslint-disable-line react-hooks/exhaustive-deps
    const classes = [styles.container];
    if (isActive) {
        classes.push(styles['is-active']);
    }
    if (onClear && value && value.length) {
        classes.push(styles['has-clear-button']);
    }
    return (
        <div className={classNames(classes)}>
            <textarea
                value={value}
                placeholder={placeholder}
                rows={rows}
                autoComplete="off"
                disabled={disabled}
                readOnly={readOnly}
                ref={textareaElement}
                {...textareaProps}
            />
            {onClear && !readOnly && !disabled && value && value.length ? (
                <div className={styles['clear-button-container']}>
                    <button
                        type="button"
                        onClick={() => {
                            focusTextarea();
                            onClear();
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            ) : null}
        </div>
    );
}

TextArea.defaultProps = {
    value: undefined,
    placeholder: undefined,
    rows: 4,
    isActive: false,
    focusOnShow: false,
    disabled: false,
    readOnly: false,
    onClear: undefined,
};

TextArea.propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    rows: PropTypes.number,
    isActive: PropTypes.bool,
    focusOnShow: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    onClear: PropTypes.func,
};

export default TextArea;
